import {NotifyHelper} from "../../../helpers/toast";
import {eAccVoucherActionsObj} from "../../action-types/category/IAccVoucherActions";
import {generateActionForKey, generateActions} from "../generateActions";

export const voucherActions = {
    ...generateActions(eAccVoucherActionsObj, "VOUCHER"),
    ...generateActionForKey(
        eAccVoucherActionsObj,
        "VOUCHER",
        "SAVE_SUCCESS",
        () => {
            NotifyHelper.Success("Đã cập nhật");
        }
    ),
    ...generateActionForKey(
        eAccVoucherActionsObj,
        "VOUCHER",
        "SAVE_ERROR",
        (m: string) => {
            NotifyHelper.Error(m);
        }
    ),
    ...generateActionForKey(
        eAccVoucherActionsObj,
        "VOUCHER",
        "DELETE_SUCCESS",
        () => {
            NotifyHelper.Success("Đã xóa");
        }
    ),
    ...generateActionForKey(
        eAccVoucherActionsObj,
        "VOUCHER",
        "DELETE_ERROR",
        (m: string) => {
            NotifyHelper.Error(m);
        }
    ),
    ...generateActionForKey(
        eAccVoucherActionsObj,
        "VOUCHER",
        "DELETE_MANY_SUCCESS",
        () => {
            NotifyHelper.Success("Đã xóa");
        }
    ),
    ...generateActionForKey(
        eAccVoucherActionsObj,
        "VOUCHER",
        "DELETE_MANY_ERROR",
        (m: string) => {
            NotifyHelper.Error(m);
        }
    ),
};
